import { BehaviorSubject, of, Subject, switchMap } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as i0 from "@angular/core";
/**
 * Service to provide the tech chart highchart instance to other tech chart components.
 */
export class TechChartChartService {
    constructor() {
        this.chart = null;
        this.xAxisZoomSubject = new Subject();
        this.mousemoveSubject = new Subject();
        this.mouseoutSubject = new Subject();
        this.chartChangeSubject = new BehaviorSubject(null);
    }
    ngOnDestroy() {
        this.unsubscribeFromSubscriptions();
    }
    /**
     * Set the chart this service manages.
     * @param chart
     */
    setChart(chart) {
        this.chart = chart;
        this.initEventEmitters();
        this.chartChangeSubject.next(this.chart);
    }
    getChart() {
        return this.chart;
    }
    xAxisZoomEvent() {
        return this.xAxisZoomSubject.asObservable().pipe(debounceTime(400), switchMap((event) => of(event)));
    }
    mousemoveEvent() {
        return this.mousemoveSubject.asObservable();
    }
    mouseoutEvent() {
        return this.mouseoutSubject.asObservable();
    }
    chartChangeEvent() {
        return this.chartChangeSubject.asObservable();
    }
    initEventEmitters() {
        if (!this.chart)
            return;
        this.unsubscribeFromSubscriptions();
        const { xAxisZoom, mousemove, mouseout } = this.chart.custom.events;
        this.xAxisZoomSubscription = xAxisZoom.subscribe((event) => {
            this.xAxisZoomSubject.next(event);
        });
        this.mousemoveSubscription = mousemove.subscribe((event) => {
            this.mousemoveSubject.next(event);
        });
        this.mouseoutSubscription = mouseout.subscribe((event) => {
            this.mouseoutSubject.next(event);
        });
    }
    unsubscribeFromSubscriptions() {
        if (this.xAxisZoomSubscription)
            this.xAxisZoomSubscription.unsubscribe();
        if (this.mousemoveSubscription)
            this.mousemoveSubscription.unsubscribe();
        if (this.mouseoutSubscription)
            this.mouseoutSubscription.unsubscribe();
    }
}
TechChartChartService.ɵfac = function TechChartChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartChartService)(); };
TechChartChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TechChartChartService, factory: TechChartChartService.ɵfac });
